import { FC } from 'react'
import {
  Edit
} from 'react-admin'
import { ActionsToolbar, HeaderTitle } from '../../components'
import CollaborationsForm from './CollaborationsForm'

const CollaborationsEdit: FC = () => (
  <Edit
    actions={<ActionsToolbar i18n="resources.collaborations.edit" />}
    title={<HeaderTitle i18n="resources.collaborations.edit" />}
    redirect="show"
  >
    <CollaborationsForm edit={true} />
  </Edit>
)

export default CollaborationsEdit
